export const hideKeyboard = () => {
   if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ name: 'hide_keyboard' }))
      window.ReactNativeWebView.postMessage(JSON.stringify({ name: 'hide_keyboard_on' }))
   }
}